module.exports = __webpack_public_path__ + "img/sunderland.d4aee960.png";